<template>
    <div>
        <div class="bubble-info" @click="show = true">
            <v-icon large :color="primaryColor">help</v-icon>
        </div>

        <v-dialog content-class="pro-dialog" v-model="show" max-width="600px">
            <v-card>
                <v-card-title>
                    <h2 class="headline-title">Une question ? Besoin d'informations ?</h2>
                </v-card-title>
                <v-card-text>
                    <v-spacer></v-spacer>
                    <p class="text-center">Contactez-nous</p>
                    <div class="mt-3 text-center">
                        <a :href="'mailto:' + email">{{ email }}</a>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "HelpModal",
    props: ['referent'],
    data() {
        return {
            show: false
        }
    },
    computed: {
        ...mapState('webFormStyle', ['primaryColor']),
        email() {
            return this.referent.emailable !== undefined ? this.referent.emailable.email : this.referent
        }
    }
}
</script>

